import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import * as _ from "lodash";
import * as moment from "moment";
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';

@IonicPage()
@Component({
  selector: 'page-program-patients',
  templateUrl: 'program-patients.html',
})
export class ProgramPatientsPage {

  program_id: string;
  program_name: string;

  patients: any;

  gridApi;
  gridColumnApi;

  rowData;
  detailCellRendererParams;
  columnDefs = [
    {headerName: 'PAT ID', field: 'patient_id', width: 100 },
    {headerName: 'IND', field: 'indication', width: 75 },
    {headerName: 'TYPE', field: 'type' },
    {headerName: 'STATUS', field: 'status' },
    {headerName: 'SUB STATUS', field: 'substatus' },
    // {
    //   headerName: "Status Date",
    //   valueGetter: (params) => {
    //     return moment(params.data.createdAt.toDate()).format("YYYY-MM-DD") // 27 January 10:30 am
    //   }
    // },
    {
      headerName: "EN REC",
      valueGetter: (params) => {
        return moment(params.data.enrolment_date).format("DD-MMM-YY") // 27 January 10:30 am
      }
    },
    {
      headerName: "FIRST CALL",
      valueGetter: (params) => {
        return moment(params.data.first_call).format("DD-MMM-YY") // 27 January 10:30 am
      }
    },
    {
      headerName: "EN DONE",
      valueGetter: (params) => {
        return moment(params.data.enrolment_done).format("DD-MMM-YY") // 27 January 10:30 am
      }
    },
    {
      headerName: "WEL PKG",
      valueGetter: (params) => {
        return moment(params.data.welcome_package).format("DD-MMM-YY") // 27 January 10:30 am
      }
    },
    {
      headerName: "REIMB COMP",
      valueGetter: (params) => {
        return moment(params.data.reimbursement_complete).format("DD-MMM-YY") // 27 January 10:30 am
      }
    },
    {
      headerName: "DRUG START",
      valueGetter: (params) => {
        return moment(params.data.drug_start).format("DD-MMM-YY") // 27 January 10:30 am
      }
    },
    {headerName: 'EC->ODS', field: 'ec_ods' },
    {headerName: 'ER->FC', field: 'er_fc' },
    {headerName: 'EC->WP', field: 'ec_wp' },
    {headerName: 'EC->RC', field: 'ec_rc' },
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    private auth: AuthProvider,
    private database: DatabaseProvider,
    public utilityService: UtilityProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;
      this.database
        .getPatientsByProgram(this.program_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            data.ec_ods = this.datediff(data.enrolment_complete_date, data.on_drug_date);
            data.er_fc = this.datediff(data.enrolment_date, data.first_call_date);
            data.ec_wp = this.datediff(data.enrolment_complete_date, data.welcome_package_date);
            data.ec_rc = this.datediff(data.enrolment_complete_date, data.reimbursement_complete_date);
            return data;
          });
        }).subscribe((patients) => {
          console.log(patients);
          this.patients = patients;
        });
    });
  }

  datediff(date1, date2)  {
    var start = moment(date2, "YYYY-MM-DD");
    var end = moment(date1, "YYYY-MM-DD");

    //Difference in number of days
    return Math.round(moment.duration(start.diff(end)).asDays());
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramPatientsPage');
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // params.api.sizeColumnsToFit();
  }

  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }
}



// WEBPACK FOOTER //
// ./src/pages/program-patients/program-patients.ts